(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  // The same clock as the product page, repeated here because a section only
  // loads its own script and the bar shows on pages the product section does
  // not. When the offer runs out the usual message takes the bar back.
  class BarCountdown {
    constructor(root) {
      this.root = root;
      this.value = root.querySelector('[data-countdown-value]');
      this.endsAt = parseInt(root.dataset.ends, 10) * 1000;
      if (!this.value || !this.endsAt) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    tick() {
      const left = this.endsAt - Date.now();
      if (left <= 0) {
        clearInterval(this.timer);
        this.root.hidden = true;
        const usual = this.root.parentElement.querySelector('[data-promo-over]');
        if (usual) {
          usual.hidden = false;
        } else {
          this.root.closest('.announcement-bar').remove();
        }
        return;
      }
      const total = Math.floor(left / 1000);
      const days = Math.floor(total / 86400);
      const hours = Math.floor((total % 86400) / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;
      const pad = (n) => String(n).padStart(2, '0');
      const left_over = days > 0
        ? days + ' j ' + pad(hours) + ' h ' + pad(minutes) + ' min'
        : pad(hours) + ' h ' + pad(minutes) + ' min ' + pad(seconds) + ' s';
      this.value.textContent = 'fin dans ' + left_over;
    }
  }

  document.querySelectorAll('.announcement-bar [data-countdown]').forEach((root) => new BarCountdown(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer {
    constructor(dialog) {
      this.dialog = dialog;
      this.cartUrl = dialog.dataset.cartUrl || '/cart';
      this.sectionId = 'cart-drawer';

      document.addEventListener('submit', (event) => this.onSubmit(event));
      document.addEventListener('click', (event) => this.onClick(event));
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) this.close();
      });
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    onClick(event) {
      const closer = event.target.closest('[data-cart-close]');
      if (closer) {
        event.preventDefault();
        this.close();
        return;
      }

      /* Quantity steps inside the drawer stay in the drawer. */
      const step = event.target.closest('[data-cart-line]');
      if (step && this.dialog.contains(step)) {
        event.preventDefault();
        this.change(Number(step.dataset.cartLine), Number(step.dataset.cartQuantity));
        return;
      }

      /* The header cart link opens the panel instead of leaving the page.
         `link.pathname` is read straight off the anchor, which the browser has
         already resolved — no URL parsing that could throw. */
      const link = event.target.closest('a[href]');
      if (!link || link.target === '_blank' || event.metaKey || event.ctrlKey) return;
      if (link.pathname === this.cartUrl && !this.dialog.contains(link)) {
        event.preventDefault();
        this.refresh().then(() => this.open());
      }
    }

    onSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || !form.action.includes('/cart/add')) return;

      event.preventDefault();
      const submitter = form.querySelector('[type="submit"]:not([disabled])');
      const body = new FormData(form);
      body.append('sections', this.sectionId);
      body.append('sections_url', window.location.pathname);

      this.busy(true, submitter);
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body })
        .then((response) => response.json())
        .then((data) => {
          /* A rejected add returns a status: say why, in the drawer, instead of
             sending the customer somewhere else. */
          if (data.status) {
            this.open();
            this.status(data.description || data.message);
            return;
          }
          this.render(data.sections && data.sections[this.sectionId]);
          this.open();
          this.status(this.dialog.dataset.addedMessage);
        })
        .catch(() => {
          /* Network failure only: fall back to the page that always works. */
          window.location.href = this.cartUrl;
        })
        .finally(() => this.busy(false, submitter));
    }

    change(line, quantity) {
      this.busy(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          sections: this.sectionId,
          sections_url: window.location.pathname
        })
      })
        .then((response) => response.json())
        .then((data) => this.render(data.sections && data.sections[this.sectionId]))
        .catch(() => window.location.reload())
        .finally(() => this.busy(false));
    }

    status(message) {
      const node = this.dialog.querySelector('[data-cart-status]');
      if (node) node.textContent = message || '';
    }

    refresh() {
      return fetch('/?sections=' + this.sectionId)
        .then((response) => response.json())
        .then((data) => this.render(data[this.sectionId]))
        .catch(() => {});
    }

    /* Swaps in the markup Shopify just rendered, so the panel can never drift
       out of step with the real cart. */
    render(markup) {
      if (!markup) return;
      const fresh = new DOMParser()
        .parseFromString(markup, 'text/html')
        .querySelector('[data-cart-drawer-content]');
      if (!fresh) return;

      const current = this.dialog.querySelector('[data-cart-drawer-content]');
      /* Keep the reading position: changing a quantity halfway down a long
         cart should not jump back to the top. */
      const list = current.querySelector('.cart-drawer__list');
      const offset = list ? list.scrollTop : 0;

      current.innerHTML = fresh.innerHTML;
      current.dataset.cartCount = fresh.dataset.cartCount;

      const newList = current.querySelector('.cart-drawer__list');
      if (newList && offset) newList.scrollTop = offset;

      this.syncHeaderCount(Number(fresh.dataset.cartCount || 0));
    }

    syncHeaderCount(count) {
      const cartLink = document.querySelector('.header__cart');
      if (!cartLink) return;
      let bubble = cartLink.querySelector('.header__cart-count');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('span');
          bubble.className = 'header__cart-count';
          bubble.setAttribute('aria-hidden', 'true');
          cartLink.appendChild(bubble);
        }
        bubble.textContent = count;
      } else if (bubble) {
        bubble.remove();
      }
    }

    /* Blocks a second click while a request is in flight, so a double tap on a
       slow connection cannot add the same pair twice. */
    busy(state, submitter) {
      this.dialog.classList.toggle('is-busy', state);
      if (submitter) submitter.disabled = state;
    }
  }

  const drawer = document.querySelector('[data-cart-drawer]');
  if (drawer && typeof drawer.showModal === 'function') new CartDrawer(drawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Only one navigation dropdown stays open at a time, and a click outside or
     the Escape key closes the open one. Written against the rendered markup so
     it also covers the nested groups inside a panel. */
  class HeaderNav {
    constructor(nav) {
      this.nav = nav;
      this.dropdowns = Array.from(nav.querySelectorAll('.header__nav-dropdown'));
      if (!this.dropdowns.length) return;

      this.dropdowns.forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          this.dropdowns.forEach((other) => {
            if (other !== details) other.open = false;
          });
        });
      });

      document.addEventListener('click', (event) => {
        if (this.nav.contains(event.target)) return;
        this.closeAll();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        this.closeAll();
      });
    }

    closeAll() {
      this.dropdowns.forEach((details) => {
        details.open = false;
      });
    }
  }

  document.querySelectorAll('.header__nav').forEach((nav) => new HeaderNav(nav));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Submitting on change saves a click. The Apply button stays in the markup
     and keeps working when this never runs. */
  const facetForm = document.getElementById('FacetForm');
  if (facetForm) {
    const apply = facetForm.querySelector('[data-facet-apply]');
    if (apply) apply.hidden = true;

    facetForm.addEventListener('change', (event) => {
      if (event.target.type === 'number') return;
      facetForm.requestSubmit();
    });

    facetForm.querySelectorAll('input[type="number"]').forEach((input) => {
      input.addEventListener('blur', () => facetForm.requestSubmit());
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          facetForm.requestSubmit();
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Counts an offer down to its deadline. The end date comes from the page,
  // which Liquid only renders while the offer is still running, so the panel
  // can never outlive the code it advertises.
  class PromoCountdown {
    constructor(root) {
      this.root = root;
      this.value = root.querySelector('[data-countdown-value]');
      this.endsAt = parseInt(root.dataset.ends, 10) * 1000;
      if (!this.value || !this.endsAt) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    tick() {
      const left = this.endsAt - Date.now();
      if (left <= 0) {
        clearInterval(this.timer);
        // The offer is over: the panel goes rather than freezing on zero.
        this.root.remove();
        return;
      }
      const total = Math.floor(left / 1000);
      const days = Math.floor(total / 86400);
      const hours = Math.floor((total % 86400) / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;
      const pad = (n) => String(n).padStart(2, '0');
      const left_over = days > 0
        ? days + ' j ' + pad(hours) + ' h ' + pad(minutes) + ' min'
        : pad(hours) + ' h ' + pad(minutes) + ' min ' + pad(seconds) + ' s';
      this.value.textContent = 'fin dans ' + left_over;
    }
  }

  document.querySelectorAll('.pdp__promo[data-countdown]').forEach((root) => new PromoCountdown(root));

  class ProductPage {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('form.pdp__form');
      if (!this.form) return;

      /* The variant payload is a sibling of the grid, not a descendant. */
      const data = root.querySelector('[data-variant-data]') || document.querySelector('[data-variant-data]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.idField = root.querySelector('[data-variant-id]');
      this.addButton = root.querySelector('[data-add-button]');
      this.addLabel = root.querySelector('[data-add-label]');

      this.form.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-input]')) this.onOptionChange();
      });

      root.querySelectorAll('[data-thumb-for]').forEach((thumb) => {
        thumb.addEventListener('click', () => this.showMedia(thumb.dataset.thumbFor));
      });

      this.setupSizeGuide();
      this.setupStickyBar();
    }

    /* The bar appears only once the real buy button has left the viewport. */
    setupStickyBar() {
      this.sticky = document.querySelector('[data-sticky-buy]');
      if (!this.sticky || !this.addButton || !('IntersectionObserver' in window)) return;

      this.stickyImage = this.sticky.querySelector('[data-sticky-image]');
      this.stickyPrice = this.sticky.querySelector('[data-sticky-price]');
      this.stickyOptions = this.sticky.querySelector('[data-sticky-options]');
      this.stickyButton = this.sticky.querySelector('[data-sticky-add]');
      this.stickyLabel = this.sticky.querySelector('[data-sticky-label]');

      const observer = new IntersectionObserver(
        ([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.sticky.hidden = !show;
          document.body.classList.toggle('has-sticky-buy', show);
        },
        { threshold: 0 }
      );
      observer.observe(this.addButton);
    }

    syncStickyBar(variant, chosen) {
      if (!this.sticky) return;
      if (this.stickyPrice && variant) this.stickyPrice.textContent = variant.price;
      if (this.stickyImage && variant && variant.mediaSrc) this.stickyImage.src = variant.mediaSrc;
      if (this.stickyOptions) this.stickyOptions.textContent = chosen.join(' / ');
      if (this.stickyButton) {
        const available = Boolean(variant && variant.available);
        this.stickyButton.disabled = !available;
        if (this.stickyLabel) {
          this.stickyLabel.textContent =
            this.stickyButton.dataset[available ? 'labelAdd' : 'labelSoldOut'];
        }
      }
    }

    get selection() {
      return Array.from(this.form.querySelectorAll('[data-option-input]:checked')).map((i) => i.value);
    }

    onOptionChange() {
      const chosen = this.selection;
      const variant = this.variants.find(
        (v) => v.options.length === chosen.length && v.options.every((o, i) => o === chosen[i])
      );

      this.refreshAvailability(chosen);
      this.root.querySelectorAll('[data-option-display]').forEach((el) => {
        el.textContent = chosen[Number(el.dataset.optionDisplay)] || '';
      });

      this.syncStickyBar(variant, chosen);

      if (!variant) {
        this.setUnavailable();
        return;
      }

      this.idField.value = variant.id;
      this.addButton.disabled = !variant.available;
      this.addLabel.textContent = this.addButton.dataset[variant.available ? 'labelAdd' : 'labelSoldOut'];
      if (variant.mediaId) this.showMedia(String(variant.mediaId));

      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    /* Re-evaluate which values are still reachable from the current selection. */
    refreshAvailability(chosen) {
      this.root.querySelectorAll('[data-option-input]').forEach((input) => {
        const index = Number(input.dataset.optionInput);
        const reachable = this.variants.some(
          (v) =>
            v.available &&
            v.options[index] === input.value &&
            v.options.every((o, i) => i === index || o === chosen[i])
        );
        input.disabled = !reachable;
        const label = this.root.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('pdp__swatch--unavailable', !reachable);
      });
    }

    setUnavailable() {
      this.addButton.disabled = true;
      this.addLabel.textContent = this.addButton.dataset.labelSoldOut;
    }

    showMedia(id) {
      this.root.querySelectorAll('.pdp__image').forEach((img) => {
        img.classList.toggle('is-active', img.dataset.mediaId === id);
      });
      this.root.querySelectorAll('.pdp__thumb').forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.thumbFor === id);
      });
    }

    setupSizeGuide() {
      const dialog = document.querySelector('dialog.size-guide');
      if (!dialog) return;
      this.root.querySelectorAll('[data-size-guide-open]').forEach((btn) => {
        btn.addEventListener('click', () => dialog.showModal());
      });
      dialog.querySelectorAll('[data-size-guide-close]').forEach((btn) => {
        btn.addEventListener('click', () => dialog.close());
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }
  }

  document.querySelectorAll('.pdp').forEach((root) => new ProductPage(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  class NewsletterPopup {
    constructor(dialog) {
      this.dialog = dialog;
      this.launcher = document.querySelector('[data-popup-launcher]');
      this.visitKey = 'mocassin:newsletter-popup-seen';
      this.doneKey = 'mocassin:newsletter-done';

      dialog.querySelectorAll('[data-popup-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });

      // Clicking the backdrop lands on the dialog itself, never on its contents.
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) this.close();
      });

      // Escape closes the dialog natively, so the launcher has to be revealed
      // here too rather than only on the close button.
      dialog.addEventListener('cancel', () => this.showLauncher());

      if (this.launcher) {
        this.launcher.addEventListener('click', () => {
          this.launcher.hidden = true;
          this.open();
        });
      }

      // A successful sign-up reloads the page, and the form then renders its
      // confirmation instead of the fields. Reopen so the visitor reads it, then
      // never ask this browser again — neither the dialog nor the launcher.
      if (dialog.querySelector('.np__success')) {
        this.write(window.localStorage, this.doneKey, '1');
        this.open();
        return;
      }

      if (this.read(window.localStorage, this.doneKey)) return;

      // Once per visit: a new tab or a new session asks again, reloading a page
      // does not. Closing it leaves the launcher in the corner.
      if (this.read(window.sessionStorage, this.visitKey)) {
        this.showLauncher();
        return;
      }

      const delay = (parseInt(dialog.dataset.delay, 10) || 0) * 1000;
      setTimeout(() => {
        this.write(window.sessionStorage, this.visitKey, '1');
        this.open();
      }, delay);
    }

    // Private browsing can refuse storage. Asking again is a better failure
    // than a script error that breaks the page.
    read(store, key) {
      try {
        return store.getItem(key) !== null;
      } catch (error) {
        return false;
      }
    }

    write(store, key, value) {
      try {
        store.setItem(key, value);
      } catch (error) {
        /* nothing to remember when storage is unavailable */
      }
    }

    showLauncher() {
      if (this.launcher && !this.read(window.localStorage, this.doneKey)) {
        this.launcher.hidden = false;
      }
    }

    open() {
      if (!this.dialog.isConnected || this.dialog.open) return;
      if (this.launcher) this.launcher.hidden = true;
      this.dialog.showModal();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
      this.showLauncher();
    }
  }

  document.querySelectorAll('[data-newsletter-popup]').forEach((dialog) => new NewsletterPopup(dialog));

  } catch(e) { console.error(e); }
})();
})();
